module.exports = __webpack_public_path__ + "static/img/IMG_20160226_135255.5ea47407.jpg";